const initialState = {
    data: [], 
    edit:[], 
    verify:[],
    remove:[],
  
  };
  
  const SupAssReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA_SUCCESS':
            return {... state, data:action.payload};
            case 'FETCH_EDIT_SUCCESS':
            return {... state, edit:action.payload};
            case 'FETCH_VER_SUCCESS':
              return {... state, verify:action.payload};
              case 'FETCH_REMOVE_SUCCESS':
              return {... state, remove:action.payload};
            
           
          


      default:
        return state;
    }
  };
  
  export default SupAssReducers;
  
  